import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


interface BinProps extends StyledProps {
  color?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const MajorDamageSVG: React.FunctionComponent<BinProps> = ({ ...rest }) => {
  return (
    <StyledContainer {...rest}>
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
          fill="#070B16"
          d="M7.029 11.01l-.35 1.304a2.652 2.652 0 00-.067.968l-.99.815a.254.254 0 01-.411-.247l.434-2.157a.254.254 0 00-.225-.303l-2.19-.212a.255.255 0 01-.116-.466l1.832-1.217a.255.255 0 00.056-.374l-1.398-1.7a.255.255 0 01.247-.41l2.156.434c.148.03.29-.075.304-.225l.212-2.19a.255.255 0 01.466-.116l1.218 1.832a.255.255 0 00.373.055l1.7-1.398a.254.254 0 01.41.247l-.318 1.58c-.077.085-.153.17-.223.264l-.904 1.208-.301.403a2.713 2.713 0 00-1.915 1.905zm13.91 3.727l-.35 1.304a1.763 1.763 0 01-.74 1.023l-.393 1.468a.897.897 0 01-1.102.637l-.87-.233a.9.9 0 01-.636-1.102l.233-.87-6.955-1.863-.233.87a.9.9 0 01-1.102.636l-.87-.233a.9.9 0 01-.636-1.102l.394-1.47a1.876 1.876 0 01-.115-.293 1.762 1.762 0 01-.015-.962l.35-1.304c.149-.557.544-.98 1.037-1.187a1.81 1.81 0 01.52-.133l.51-.681.904-1.209a3.166 3.166 0 011.49-1.092 3.123 3.123 0 011.847-.063l3.45.924a3.126 3.126 0 012.312 2.67l.18 1.498.1.846c.293.21.516.503.64.841.124.335.15.709.05 1.08zm-10.75-3.346c-.522-.14-.963.113-1.102.633-.14.52.115.96.637 1.1.521.14 1.28.436 1.42-.084.14-.52-.434-1.51-.956-1.65zm8.173.792l-.18-1.499a1.347 1.347 0 00-.99-1.144l-3.45-.924a1.35 1.35 0 00-1.431.495l-.904 1.208 4.837 1.296 2.118.568zm.52 1.537c-.522-.14-1.514.43-1.653.95s.667.643 1.188.783c.522.14.962-.114 1.102-.633.14-.52-.116-.96-.637-1.1z"
        />
      </svg>
    </StyledContainer>
  );
};

export default MajorDamageSVG;
